const updateLoginData = {
    username: "studentX",
    password: "TestLoginUpdate"
}

export default updateLoginData